import {SODeleteRelationship} from '../../core/relationship/so-delete-relationship';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteRelationship extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteRelationship;
}